export default "__VITE_ASSET__3f06a514__"